import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Tooltip, Typography} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {SECTIONS} from './atelierRules';
import {
    ChampsAvances, ChampsBudgets, ChampsCollecte, ChampsCouts, ChampsDepart, ChampsEquipes, ChampsPeriode, ChampsVerrous,
} from './SimulationWizardFields';
import {CARD_SX, Eyebrow} from '../interventions/v2/primitives.js';

/**
 * Volet gauche de l'atelier (≈ 360 px) : les champs du wizard V1 (mêmes composants, mêmes validations, mêmes 422),
 * en sections repliables, dans l'ordre du mandat. Le bouton Jouer est posé par la page, fixe en bas du volet.
 * AJOUT À VALIDER (GUIDE_UI) : sections repliables de formulaire dans un volet — tokens existants seulement.
 */

const ACCORDEON_SX = {
    boxShadow: 'none', borderBottom: '1px solid #EEF1F4', '&:before': {display: 'none'},
    '&.Mui-expanded': {margin: 0},
};

function Section({id, titre, ouverte, onToggle, enErreur, children}) {
    return (
        <Accordion disableGutters square expanded={ouverte} onChange={() => onToggle(id)} sx={ACCORDEON_SX}
                   data-testid={`section-${id}`}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>} sx={{px: 2.5}}>
                <Eyebrow sx={{color: enErreur ? '#B22222' : '#213067'}}>{titre}</Eyebrow>
            </AccordionSummary>
            <AccordionDetails sx={{px: 2.5, pt: 0, pb: 2}}>{children}</AccordionDetails>
        </Accordion>
    );
}

function AtelierVolet({
    formik, tentee, patrimoine, agences, agencesLoading, aCalendrier, calendrierLoading, calendrierErreur,
    ouvertes, onToggle, sectionsFautives, erreursGlobales, pied, onReplier,
}) {
    const section = (id, children) => (
        <Section id={id} titre={SECTIONS.find((s) => s.id === id).titre} ouverte={ouvertes.includes(id)} onToggle={onToggle}
                 enErreur={tentee && sectionsFautives.includes(id)}>
            {children}
        </Section>
    );
    return (
        <Box sx={{...CARD_SX, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0}} data-testid="volet-atelier">
            {onReplier &&
                <Box sx={{flex: 'none', display: 'flex', alignItems: 'center', justifyContent: 'space-between', pl: 2.5, pr: 1, py: 0.5, borderBottom: '1px solid #EEF1F4'}}>
                    <Eyebrow>Curseurs</Eyebrow>
                    <Tooltip title="Replier le volet">
                        <IconButton size="small" aria-label="Replier le volet" onClick={onReplier} data-testid="replier-volet"><ChevronLeftIcon/></IconButton>
                    </Tooltip>
                </Box>}
            <Box sx={{flex: '1 1 auto', overflowY: 'auto', minHeight: 0}}>
                {erreursGlobales.length > 0 &&
                    <Box sx={{m: 2, p: 1.5, borderRadius: '12px', bgcolor: '#FBE6E6', border: '1px solid #F0BDBD', color: '#B22222', fontSize: 13}}>
                        {erreursGlobales.map((m, i) => <div key={i}>{m}</div>)}
                    </Box>}

                {section('periode', <ChampsPeriode formik={formik} tentee={tentee} compact libelleFacultatif/>)}
                {section('equipes', <>
                    <ChampsEquipes formik={formik} tentee={tentee} compact/>
                    <ChampsDepart formik={formik} tentee={tentee} agences={agences} agencesLoading={agencesLoading} compact/>
                </>)}
                {section('collecte', <ChampsCollecte formik={formik} tentee={tentee} aCalendrier={aCalendrier}
                                                     calendrierLoading={calendrierLoading} calendrierErreur={calendrierErreur} compact/>)}
                {section('budgets', <ChampsBudgets formik={formik} tentee={tentee} compact/>)}
                {section('couts', <ChampsCouts formik={formik} tentee={tentee} compact/>)}
                {section('verrous', <ChampsVerrous formik={formik} tentee={tentee} compact/>)}
                {section('avance', <ChampsAvances formik={formik} tentee={tentee} patrimoine={patrimoine} compact/>)}

                <Typography variant="caption" sx={{display: 'block', px: 2.5, py: 1.5, color: '#8A929C'}}>
                    Simulation : ne crée rien dans l'ERP.
                </Typography>
            </Box>
            <Box sx={{flex: 'none', p: 2, borderTop: '1px solid #EEF1F4', bgcolor: '#fff'}}>{pied}</Box>
        </Box>
    );
}

export default AtelierVolet;
